import {createGlobalStyle} from "styled-components";

const ContactStyle = createGlobalStyle`
       .contact{
            min-height: calc(100vh - 250px);
            display: flex;
            justify-content: center;
            .contactIcon{
                width: 50px
            }
            .contactHeading{
                font-weight: 600;
                font-size: 70px;
                line-height: 80px;
                margin-top: 30px;
            }
            .contactContent{
                text-align: right;
                font-size: 40px;
                font-weight: 500;
            }
       }
       @media only screen and (max-width: 992px) {
      .contact {
          min-height: calc(100vh - 290px);
             .contactIcon{
                width: 30px;
             }
             .contactHeading{
                font-weight: 600;
                font-size: 30px;
                line-height: normal;
                margin-top: 0;
            }
            .contactContent {
                text-align: unset;
                font-size: 20px;
                font-weight: 500;
            }
      }
    .heroButton-section {
         margin-top: 20px;
    }
      }
`;

export default ContactStyle;
